import { render } from "./ContractorSbsReport.vue?vue&type=template&id=3128ff21&scoped=true"
import script from "./ContractorSbsReport.vue?vue&type=script&lang=js"
export * from "./ContractorSbsReport.vue?vue&type=script&lang=js"

import "./ContractorSbsReport.vue?vue&type=style&index=0&id=3128ff21&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3128ff21"]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QBtn,QChip,QIcon,QTooltip,QTr,QPopupProxy,QTd,QSpinner,QMenu,QList,QItem,QItemSection,QField});
